// HeaderCarousel.js
import React from 'react';

const Frontpage = () => {
  const backgroundImage = "/images/home.jpg"; // Update with the correct path

  return (
    <div className="mt-24" >
      <div className="">
        <CarouselItem
          imageUrl={backgroundImage}
          title="// The Best Bakery"
          heading="We Bake With Passion"
          description="Vero elitr justo clita lorem. Ipsum dolor sed stet sit diam rebum ipsum."
        />
      </div>
    </div>
  );
};

const CarouselItem = ({ imageUrl, title, heading, description }) => {
  return (
    <div className="relative bg-cover bg-center min-h-max md:min-h-screen" style={{ backgroundImage: `url(${imageUrl})`, backgroundSize: 'cover' }}>
    <div className="absolute inset-0 flex items-center justify-start md:ml-28 mt-24">
      <div className="text-white text-left p-5">
        <h1 className="text-1xl font-bold mb-2">{title}</h1>
        <h2 className="text-6xl font-extrabold mb-4 animated slideInDown">{heading}</h2>
        <p className="text-lg mb-4 pb-3">{description}</p>
        <button className="bg-amber-400 p-2 md:p-3 lg:p-4 hover:bg-blue-700 text-white font-bold py-3 px-5 md:py-4 md:px-6 lg:py-5 lg:px-7 rounded-full">
          Read more
        </button>
      </div>
    </div>
  </div>
  );
};

export default Frontpage;
